import React, { useState } from "react";
import { Popup, Position, ToolbarItem } from "devextreme-react/popup";
import Loader from "./Loader";
import CustomSelection from "./CustomSelection";
import { logos } from "../search/config";

const ReportInfoModal = ({ visible, handleCancel, viewReport }) => {
  const ready = true;
  const [reportInfo, setReportInfo] = useState({});

  const handleChange = (e, dataField) => {
    setReportInfo((prevInfo) => ({
      ...prevInfo,
      [dataField]: e.value,
    }));
  };

  return (
    <Popup
      visible={!!visible}
      closeOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title="Report Additional Info"
      container=".dx-viewport"
      width={400}
      height={500}
    >
      {!ready && <Loader />}
      <p>Address:</p>
      <CustomSelection
        value={reportInfo.address_id}
        resourceName="addresses"
        resourcePath="address"
        displayExpr="name"
        valueExpr="id"
        handleChange={(e) => handleChange(e, "address_id")}
      />
      <p>Bank:</p>
      <CustomSelection
        value={reportInfo.bank_id}
        resourceName="banks"
        resourcePath="bank"
        displayExpr="name"
        valueExpr="id"
        handleChange={(e) => handleChange(e, "bank_id")}
      />
      <p>Logo Top Left:</p>
      <CustomSelection
        dataSource={logos}
        value={reportInfo.logo_tl}
        handleChange={(e) => handleChange(e, "logo_tl")}
      />
      <p>Logo Bottom Right:</p>
      <CustomSelection
        dataSource={logos}
        value={reportInfo.logo_br}
        handleChange={(e) => handleChange(e, "logo_br")}
      />

      <Position at="center" my="center" />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        options={{
          icon: "check",
          text: "View report",
          onClick: () => {
            viewReport(reportInfo);
            handleCancel();
          },
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "close",
          text: "Cancel",
          onClick: handleCancel,
        }}
      />
    </Popup>
  );
};

export default ReportInfoModal;
